module.exports = __webpack_public_path__ + "media/components/src/assets/images/tables/block_table_3-5c7d77c4649e2cca457d1677b6516c8c.jpg";